/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjects_Subject_History15Inputs */

const en__field__enum_teachingsubjects_subject_history15 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_History15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`History`)
};

const de__field__enum_teachingsubjects_subject_history15 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_History15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschichte`)
};

/**
* | output |
* | --- |
* | "History" |
*
* @param {_Field__Enum_Teachingsubjects_Subject_History15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjects_subject_history15 = /** @type {((inputs?: _Field__Enum_Teachingsubjects_Subject_History15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjects_Subject_History15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjects_subject_history15(inputs)
	return de__field__enum_teachingsubjects_subject_history15(inputs)
});
export { _field__enum_teachingsubjects_subject_history15 as "_field__enum_teachingSubjects_SUBJECT_HISTORY" }